import { useCallback, useState } from 'react';

export const useSliderValues = ({
  value,
  defaultValue,
  onValueChange,
}: {
  value?: number[];
  defaultValue?: number[];
  onValueChange?: (values: number[]) => void;
}) => {
  const [localValues, setLocalValues] = useState<number[]>(defaultValue ?? [0]);
  const isControlled = value !== undefined;
  const values = isControlled ? value : localValues;

  const handleValueChange = useCallback(
    (newValues: number[]) => {
      if (!isControlled) setLocalValues(newValues);
      onValueChange?.(newValues);
    },
    [onValueChange, isControlled],
  );

  return [values, handleValueChange] as const;
};
